import { FC, ReactNode, Dispatch, SetStateAction } from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  makeStyles,
  Accordion as MuiAccordion,
  Typography,
  withStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const useStyles = makeStyles(theme => ({
  disclosure: {
    background: theme.palette.white,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  disclosureTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  disclosureIconOpen: {
    transition: 'all 0.5s',
    transform: 'rotate(180deg)',
  },
  disclosureIconClose: {
    transition: 'all 0.5s',
    transform: 'rotate(0deg)',
  },
}));

interface Props {
  children?: ReactNode;
  label: string;
  bold: string;
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
}

export const DeploymentPreviewDisclosure: FC<Props> = ({
  children,
  label,
  bold,
  expanded,
  setExpanded,
}) => {
  const classes = useStyles();

  return (
    <Accordion
      expanded={expanded}
      className={classes.disclosure}
      onChange={() => {
        setExpanded(e => !e);
      }}
    >
      <AccordionSummary>
        <Box className={classes.disclosureTitle}>
          <ExpandMoreIcon
            className={
              expanded
                ? classes.disclosureIconOpen
                : classes.disclosureIconClose
            }
          />
          <Typography>
            {label}{' '}
            <Typography component="span" style={{ fontWeight: 700 }}>
              {bold}
            </Typography>
          </Typography>
        </Box>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
